import React, { useCallback, useEffect, useRef, useState } from "react";
import "../styles/Board.css";
import { useGame } from "../GameContext";
import Endings from "./hooks/Endings";
interface VodyanoyApp {
  GameType: "ball" | "beaker";
  VolumeA: number;
  VolumeB: number;
  WinVolume: number;
}

const Board: React.FC<VodyanoyApp> = ({
  GameType,
  VolumeA,
  VolumeB,
  WinVolume,
}) => {
  const {
    gameMode,
    currentAction,
    setGameMode,
    setMessage,
    setBlockTransButton,
    setBlockNextButton,
  } = useGame();
  const [programText, setProgramText] = useState("");
  // Выполняемая строка
  const [currentLine, setCurrentLine] = useState<number>(-1);
  const [debugLineIndex, setDebugLineIndex] = useState<number>(-1);
  // Строка с ошибкой
  const [errorLine, setErrorLine] = useState<number>(-1);
  // Флаг окончания выполнения отладки
  const [isDebugFinished, setIsDebugFinished] = useState(false);
  // Общее состояние победы на всю игру
  const GameWinRef = useRef(false);
  const VesselWinRef = useRef<string>("");

  // Таймеры для каждого сосуда
  const intervalA = useRef<NodeJS.Timer | null>(null);
  const intervalB = useRef<NodeJS.Timer | null>(null);
  // Объём воды в сосудах
  const volumeRef = useRef({ A: 0, B: 0 });
  const [volumeRender, setVolumeRender] = useState({ A: 0, B: 0 });
  // Значения отображений уровней воды (кадры воды)
  const levelRef = useRef({ A: 0, B: 0 });
  const [levelRender, setLevelRender] = useState({ A: 0, B: 0 });
  const targetLevelRef = useRef({ A: 0, B: 0 });
  // Объём сосудов
  const vesselVolumeA: number = VolumeA;
  const vesselVolumeB: number = VolumeB;
  // Необходимый объём для победы
  const vesselVolumeWin: number = WinVolume;
  // Номер максимального кадра для сосудов А и B от 0
const precentlevelA = { min: 30, max: 90 }; // min = полный, max = пустой
const precentlevelB = { min: 42, max: 92 };
  // Индивидуальный айди выполняемого режима run
  const executionIdRef = useRef(0);
  // Флаг предварительной загрузки изображений
  const [isAssetsReady, setIsAssetsReady] = useState(false);
  // Предзагруженный кадры


  //Установка объема воды в сосуде для двух переменных
  const setVolume = (side: "A" | "B", val: number) => {
    volumeRef.current[side] = val;
    setVolumeRender({ ...volumeRef.current });
  };

  //Установка уровня воды в сосуде для двух переменных
  const setLevel = (side: "A" | "B", val: number) => {
    levelRef.current[side] = val;
    setLevelRender({ ...levelRef.current });
  };

  useEffect(() => {
    setIsAssetsReady(false);
    
    // const base =
    //   GameType === "ball" ? "/img/vodyanoy/ball" : "/img/vodyanoy/beaker";

    const load = (src: string) =>
      new Promise<void>((res) => {
        const img = new Image();
        img.src = src;
        img.onload = img.onerror = () => res();
      });

    // const loadFrames = async (side: "A" | "B", max: number) => {
    //   const tasks = Array.from({ length: max + 1 }, (_, i) => {
    //     const src = `${base}/${GameType}_${side}/${GameType}_${side}_${i}.svg`;
    //     const img = new Image();
    //     img.src = src;
    //     framesRef.current[side][i] = img;

    //     return new Promise<void>((res) => {
    //       img.onload = img.onerror = () => res();
    //     });
    //   });

    //   await Promise.all(tasks);
    // };

    Promise.all([
      load("/img/vodyanoy/frog_vodyanoy.svg"),
      load("/img/vodyanoy/fon_vodyanoy.svg"),
      load("/img/vodyanoy/cork.svg"),
      load("/img/vodyanoy/ball/ball_B/ball_B_0v1.svg"),
      load("/img/vodyanoy/ball/ball_A/ball_A_0v3.svg"),
      load("/img/vodyanoy/ball/ball_A/ball_A_water.svg"),
      load("/img/vodyanoy/ball/ball_B/ball_B_water.svg"),
    ]).then(() => setIsAssetsReady(true));
  }, [GameType]);

  // Функция подсчета кадров на опредленный объём сосуда
  // const volumeToFrame = (
  //   volume: number,
  //   vesselVolume: number,
  //   position: "A" | "B", //сторона сосуда (A/B)
  // ) => {
  //   let maxFrame = position === "A" ? framelevelA : framelevelB;
  //   return Math.min(maxFrame, Math.ceil((volume / vesselVolume) * maxFrame));
  // };
const volumeToPercent = (
  volume: number,
  vesselVolume: number,
  position: "A" | "B"
) => {
  const { min, max } =
    position === "A" ? precentlevelA : precentlevelB;

  const fill = volume / vesselVolume;

  return max - fill * (max - min);
};
  const stopAllAnimations = () => {
    if (intervalA.current) {
      clearInterval(intervalA.current);
      intervalA.current = null;
      setLevel("A", targetLevelRef.current.A);
    }

    if (intervalB.current) {
      clearInterval(intervalB.current);
      intervalB.current = null;
      setLevel("B", targetLevelRef.current.B);
    }
  };
  // Изменение кадра воды
  const animateWater = (
  side: "A" | "B",
  to: number,
  intervalRef: React.MutableRefObject<NodeJS.Timer | null>,
  executionId?: number
) => {
  return new Promise<void>((resolve) => {
    if (executionId !== undefined && executionId !== executionIdRef.current) {
      resolve();
      return;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    targetLevelRef.current[side] = to;
    const from = levelRef.current[side];
    if (from === to) {
      resolve();
      return;
    }

    let current = from;
    const step = from < to ? 0.5 : -0.5; // шаг в процентах, плавнее
    intervalRef.current = setInterval(() => {
      if (executionId !== undefined && executionId !== executionIdRef.current) {
        clearInterval(intervalRef.current!);
        intervalRef.current = null;
        resolve();
        return;
      }

      current += step;

      // чтобы не выйти за пределы
      if ((step > 0 && current >= to) || (step < 0 && current <= to)) {
        current = to;
      }

      setLevel(side, current);

      if (current === to) {
        clearInterval(intervalRef.current!);
        intervalRef.current = null;
        resolve();
      }
    }, 35); // 20ms → плавно
  });
};

  // Парсер команд переливания
  const PourWater = useCallback(
    async (command: string, executionId?: number) => {
      if (executionId !== undefined && executionId !== executionIdRef.current) {
        return;
      }
      let from: "A" | "B" | null = null;
      let to: "A" | "B" | null = null;
      let targetVolume = 0;

      switch (command) {
        case "AB":
          from = "A";
          to = "B";
          targetVolume = vesselVolumeB;
          break;
        case "BA":
          from = "B";
          to = "A";
          targetVolume = vesselVolumeA;
          break;
        case "AC":
          from = "A";
          targetVolume = 0;
          break;
        case "BC":
          from = "B";
          targetVolume = 0;
          break;
        case "CA":
          from = "A";
          targetVolume = vesselVolumeA;
          break;
        case "CB":
          from = "B";
          targetVolume = vesselVolumeB;
          break;
      }
      stopAllAnimations();
      if (executionId !== undefined && executionId !== executionIdRef.current) {
        return;
      }
      if (from && to) {
        setVolumeRender({ ...volumeRef.current });
        const transfer = Math.min(
          volumeRef.current[from],
          targetVolume - volumeRef.current[to],
        );

        if (transfer <= 0) return;
        volumeRef.current[from] = volumeRef.current[from] - transfer;
        volumeRef.current[to] = volumeRef.current[to] + transfer;

        await Promise.all([
          animateWater(
            from,
            volumeToPercent(
              volumeRef.current[from],
              from === "A" ? vesselVolumeA : vesselVolumeB,
              from,
            ),
            from === "A" ? intervalA : intervalB,
            executionId,
          ),
          animateWater(
            to,
            volumeToPercent(
              volumeRef.current[to],
              to === "A" ? vesselVolumeA : vesselVolumeB,
              to,
            ),
            to === "A" ? intervalA : intervalB,
            executionId,
          ),
        ]);
        setVolumeRender({ ...volumeRef.current });
      } else if (from) {
        setVolumeRender({ ...volumeRef.current });
        volumeRef.current[from] = targetVolume;
        await animateWater(
          from,
          volumeToPercent(
            targetVolume,
            from === "A" ? vesselVolumeA : vesselVolumeB,
            from,
          ),
          from === "A" ? intervalA : intervalB,
          executionId,
        );
        setVolumeRender({ ...volumeRef.current });
      }
    },
    [vesselVolumeA, vesselVolumeB],
  );

  // Функция для проверки победы игры
  const GameWin = () => {
    if (
      volumeRef.current["A"] === vesselVolumeWin ||
      volumeRef.current["B"] === vesselVolumeWin
    ) {
      if (volumeRef.current["A"] === vesselVolumeWin)
        VesselWinRef.current = "A";
      else VesselWinRef.current = "B";
      if (gameMode === "Control")
        setMessage(
          "Ты получил нужный объём! Молодец! Теперь напиши программу.",
        );
      else if (gameMode === "Debug" || gameMode === "Run")
        setMessage("Ты получил нужный объём! Молодец!");
      GameWinRef.current = true;
      return true;
    }
    return false;
  };
  // Функция для проверки ошибок игры
  const checkPourError = (
    fromSide: "A" | "B" | "C",
    toSide: "A" | "B" | "C",
    lineIndex?: number,
  ): string | null => {
    const fromVolume = fromSide === "C" ? 0 : volumeRef.current[fromSide];
    const toVolume = toSide === "C" ? 0 : volumeRef.current[toSide];

    const maxTo =
      toSide === "A" ? vesselVolumeA : toSide === "B" ? vesselVolumeB : 0;

    if (fromSide !== "C" && fromVolume === 0) {
      if (lineIndex !== undefined) setErrorLine(lineIndex);
      return "Не могу вылить из пустого сосуда";
    }

    if (toSide !== "C" && toVolume === maxTo) {
      if (lineIndex !== undefined) setErrorLine(lineIndex);
      return "Не могу налить в полный сосуд";
    }
    if (fromSide === toSide) {
      if (lineIndex !== undefined) setErrorLine(lineIndex);
      return "Нельзя переливать в тот же сосуд";
    }
    return null;
  };

  //Следующий шаг отладки
  const debugNextStep = async () => {
    const lines = programText
      .split("\n")
      .map((l) => l.trim())
      .filter(Boolean);
    if (!programText.trim()) {
      setMessage("Программы нет");
      setIsDebugFinished(true);
      setBlockNextButton(true);
      return;
    }
    let i = debugLineIndex + 1;
    setCurrentLine(i);
    setDebugLineIndex(i);
    setErrorLine(-1);

    const match = lines[i].match(/^pour\(\s*([ABC])\s*,\s*([ABC])\s*\)$/i);
    if (!match) {
      setMessage(`Неверная команда: "${lines[i]}"`);
      setErrorLine(i);
      setIsDebugFinished(true);
      setBlockNextButton(true);
      return;
    }

    const fromSide = match[1].toUpperCase() as "A" | "B" | "C";
    const toSide = match[2].toUpperCase() as "A" | "B" | "C";
    const errorMessage = checkPourError(fromSide, toSide);
    if (errorMessage) {
      setMessage(errorMessage);
      setErrorLine(i);
      setBlockNextButton(true);
      return;
    }
    if (i === lines.length - 1) {
      setBlockNextButton(true);
    }

    await PourWater(`${fromSide}${toSide}`);

    if (i === lines.length - 1) {
      setDebugLineIndex(-1);
      setCurrentLine(-1);
      setIsDebugFinished(true);
      if (GameWin()) {
      } else {
        setMessage("Конец программы");
      }
      return;
    }
  };
  //Предугадывание победы в Control(режим джойстика)
  const willWin = (side: string) => {
    let a = volumeRef.current.A;
    let b = volumeRef.current.B;

    if (side === "AB") {
      const t = Math.min(a, vesselVolumeB - b);
      a -= t;
      b += t;
    } else if (side === "BA") {
      const t = Math.min(b, vesselVolumeA - a);
      b -= t;
      a += t;
    } else if (side === "AC") {
      a = 0;
    } else if (side === "BC") {
      b = 0;
    } else if (side === "CA") {
      a = vesselVolumeA;
    } else if (side === "CB") {
      b = vesselVolumeB;
    }

    return a === vesselVolumeWin || b === vesselVolumeWin;
  };
  // Режим Control (джойстика)
  const controlPour = async (side: string) => {
    if (GameWinRef.current) {
      return;
    }
    setMessage(" ");
    if (willWin(side)) {
      setBlockTransButton(true);
    }
    const fromSide = side[0] as "A" | "B" | "C";
    const toSide = side[1] as "A" | "B" | "C";

    const errorMessage = checkPourError(fromSide, toSide);
    if (errorMessage) {
      setMessage(errorMessage);
      return;
    }
    await PourWater(side);
    if (GameWin()) {
    }
  };

  const executeProgram = async () => {
    const myExecutionId = ++executionIdRef.current;
    if (GameWinRef.current) {
      return;
    }
    if (!programText.trim()) {
      setMessage("Программы нет");
      return;
    }
    const lines = programText
      .split("\n")
      .map((l) => l.trim())
      .filter(Boolean);
    setErrorLine(-1);
    for (let i = 0; i < lines.length; i++) {
      if (myExecutionId !== executionIdRef.current) return;

      setCurrentLine(i);

      const match = lines[i].match(/^pour\(\s*([ABC])\s*,\s*([ABC])\s*\)$/i);
      if (!match) {
        setMessage(`Неверная команда: "${lines[i]}"`);
        setErrorLine(i);
        return;
      }

      const fromSide = match[1].toUpperCase() as "A" | "B" | "C";
      const toSide = match[2].toUpperCase() as "A" | "B" | "C";
      const errorMessage = checkPourError(fromSide, toSide, i);
      if (errorMessage) {
        setMessage(errorMessage);
        return;
      }

      await PourWater(`${fromSide}${toSide}`, myExecutionId);
    }
    if (GameWin()) {
      setCurrentLine(-1);
      return;
    }
    if (myExecutionId === executionIdRef.current) {
      setCurrentLine(-1);
      setMessage("Конец программы");
    }
  };

  // добавление команд в консоль при нажатии на кнопку
  const handleAddCommand = useCallback(
    (command: string) => {
      if (gameMode === "Edit") {
        setProgramText((prev) => (prev ? prev + "\n" + command : command));
      }
    },
    [gameMode],
  );

  const pourMap: Record<string, string> = {
    AB: "a,b",
    BA: "b,a",
    BC: "b,c",
    CB: "c,b",
    AC: "a,c",
    CA: "c,a",
  };

  useEffect(() => {
    if (!currentAction) return;

    if (currentAction === "stop") {
      setGameMode("Edit");
      return;
    }

    if (currentAction === "next") {
      debugNextStep();
      return;
    }

    const pour = pourMap[currentAction];
    if (!pour) return;

    if (gameMode === "Control") {
      controlPour(currentAction);
    } else {
      handleAddCommand(`pour(${pour})`);
    }
  }, [currentAction, gameMode]);
  // Обнуление игры
  const ResetGame = useCallback(() => {
    executionIdRef.current++;

    if (intervalA.current) clearInterval(intervalA.current);
    if (intervalB.current) clearInterval(intervalB.current);
    intervalA.current = null;
    intervalB.current = null;

    setBlockNextButton(false);
    setBlockTransButton(false);
    setVolume("A", 0);
    setVolume("B", 0);
   setLevel("A", precentlevelA.max);
setLevel("B", precentlevelB.max);
    setIsDebugFinished(false);
    GameWinRef.current = false;
    VesselWinRef.current = "";
    setDebugLineIndex(-1);
    setCurrentLine(-1);
    setErrorLine(-1);
    setMessage(
      `Подготовь ${vesselVolumeWin} ${Endings(vesselVolumeWin, GameType)} живой воды в любом сосуде`,
    );
  }, []);

  // Запуск режима Run
  useEffect(() => {
    ResetGame();

    if (gameMode === "Run") {
      executeProgram();
    }
  }, [gameMode]);

  const renderProgram = useCallback(() => {
    if (programText.trim() === "") {
      return <div className="car-program-empty">Программа пуста</div>;
    }

    const lines = programText.split("\n").filter((line) => line.trim() !== "");

    return lines.map((line, index) => {
      let className = "car-program-line";
      if (index === currentLine) className += " current-line";
      if (index === errorLine) className += " error-line";

      return (
        <div key={index} className={className}>
          {line}
        </div>
      );
    });
  }, [programText, currentLine, errorLine]);

  return (
    <div className="vod-Board">
      <div className="vod-Scene">
        {!isAssetsReady ? (
          <div className="vod-board-loading">
            <div className="vod-loading-text">Загрузка...</div>
          </div>
        ) : (
          <>
            <img
              className="vod-BackgroundImg"
              src={`/img/vodyanoy/fon_vodyanoy.svg`}
              alt="Фон"
            />
            <div className={`vod-vessel vod-${GameType}VesselA`}>
              <span className={`vod-textVessel vod-textVessel${GameType}_A`}>
                {vesselVolumeA}
              </span>
              <div
                className={
                  `vod-Frog_and_TextVolume vod-Frog_TextVolume_${GameType}A` +
                  (VesselWinRef.current === "A" ? " vod-WinFrogTextVolume" : "")
                }
              >
                <img
                  className={`vod-frog`}
                  src={`/img/vodyanoy/frog_vodyanoy.svg`}
                  alt={`Frog${GameType}A`}
                ></img>
                <span className={`vod-textVolume`}>{volumeRender.A}</span>
              </div>

              {VesselWinRef.current === "A" && (
                <img
                  className={`vod-cork_A vod-cork_${GameType}A`}
                  src={`/img/vodyanoy/cork.svg`}
                  alt="cork A"
                />
              )}
              {/* <img
                className="vod-img-VesselA"
                src={`/img/vodyanoy/${GameType}/${GameType}_A/${GameType}_A_${levelRender.A}.svg`}
                alt={`${GameType}A`}
              ></img> */}
               <img
                className="vod-img-VesselA-water"
                src={`/img/vodyanoy/${GameType}/${GameType}_A/${GameType}_A_water.svg`}
                alt={`${GameType}A`}
                style={{ clipPath: `inset(${levelRender.A}% 0 0 0)` }}
              ></img>
              <img
                className="vod-img-VesselA"
                src={`/img/vodyanoy/${GameType}/${GameType}_A/${GameType}_A_0v3.svg`} // варианты сосудов
                alt={`${GameType}A`}
              ></img> 
            </div>
            <div className={`vod-vessel vod-${GameType}VesselB`}>
              <div
                className={
                  `vod-Frog_and_TextVolume vod-Frog_TextVolume_${GameType}B` +
                  (VesselWinRef.current === "B" ? " vod-WinFrogTextVolume" : "")
                }
              >
                <img
                  className={`vod-frog`}
                  src={`/img/vodyanoy/frog_vodyanoy.svg`}
                  alt={`Frog${GameType}B`}
                />
                <span className={`vod-textVolume`}>{volumeRender.B}</span>
              </div>

              <span className={`vod-textVessel vod-textVessel${GameType}_B`}>
                {vesselVolumeB}
              </span>
              {VesselWinRef.current === "B" && (
                <img
                  className={`vod-cork_B vod-cork_${GameType}B`}
                  src={`/img/vodyanoy/cork.svg`}
                  alt="cork B"
                />
              )}
               <img
                className="vod-img-VesselB-water"
                src={`/img/vodyanoy/${GameType}/${GameType}_B/${GameType}_B_water.svg`}
                alt={`${GameType}B`}
                style={{ clipPath: `inset(${levelRender.B}% 0 0 0)` }}
              ></img>
              <img
                className="vod-img-VesselB"
                src={`/img/vodyanoy/${GameType}/${GameType}_B/${GameType}_B_0v1.svg`} // варианты сосудов
                alt={`${GameType}`}
              ></img> 
              {/* <img
                className="vod-img-VesselB"
                src={`/img/vodyanoy/${GameType}/${GameType}_B/${GameType}_B_20.svg`}
                alt={`${GameType}B`}
              ></img> */}
            </div>
          </>
        )}
      </div>

      <div className="vod-Management-bar">
        {gameMode === "Run" || gameMode === "Debug" ? (
          <div className="vod-console run">{renderProgram()}</div>
        ) : (
          <textarea
            className="vod-console edit"
            value={programText}
            onChange={(e) => setProgramText(e.target.value)}
            style={{
              background: gameMode === "Edit" ? "rgb(227, 241, 250)" : "white",
              pointerEvents: gameMode !== "Edit" ? "none" : "auto",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Board;
